<template>
  <div class="over_layout">
    <section class="error_page">
      <div class="wrapper">
        <div class="top_icon_error">
          <img src="/vue/images/error_icon_top.png">
        </div>
        <div class="text_error_404">
          <strong>4</strong>
          <div class="icon_0">
            <img src="/vue/images/error_lightbulb_OFF.png">
          </div>
          <strong>4</strong>
        </div>
        <p>{{ $store.getters.t('sorry_404') }}</p>
        <div class="button_style">
          <router-link
            :to="{name: 'home' , params: {lang: $store.getters.locale }}"
          >{{ $store.getters.t('backtohomepage') }}</router-link>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$parent.getData();
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/errors/404.vue